"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contacts = void 0;
const zod_1 = require("zod");
exports.contacts = zod_1.z.object({
    contactIds: zod_1.z.array(zod_1.z.string()).optional(),
    includeDeleted: zod_1.z.boolean().default(false).optional(),
    attributes: zod_1.z
        .object({
        contactId: zod_1.z.literal(true).optional(),
        createdAt: zod_1.z.literal(true).optional(),
        deletedAt: zod_1.z.literal(true).optional(),
        email: zod_1.z.literal(true).optional(),
        language: zod_1.z.literal(true).optional(),
        name: zod_1.z.literal(true).optional(),
        sms: zod_1.z.literal(true).optional(),
        updatedAt: zod_1.z.literal(true).optional(),
        groupsForContact: zod_1.z
            .object({
            createdAt: zod_1.z.literal(true).optional(),
            groupId: zod_1.z.literal(true).optional(),
            name: zod_1.z.literal(true).optional(),
            updatedAt: zod_1.z.literal(true).optional(),
        })
            .optional()
            .refine((args) => !args || !!Object.keys(args || {}).length, {
            message: 'Must request at least one attribute of the groups',
        }),
    })
        .optional()
        .refine((args) => !args || !!Object.keys(args || {}).length, {
        message: 'Must request at least one attribute for the user if specifying any at all',
    }),
});
//# sourceMappingURL=contacts.js.map